import { FaWhatsapp, FaPhone, FaEnvelope, FaMapMarkerAlt } from 'react-icons/fa';
import { Link } from 'react-router-dom';
import '../styles/footer.css';

const Footer = () => {
  const currentYear = new Date().getFullYear();

  const quickLinks = [
    { name: 'Home', path: '/' },
    { name: 'About Us', path: '/about' },
    { name: 'Services', path: '/services' },
    { name: 'Contact', path: '/contact' },
  ];

  const contactInfo = [
    { icon: <FaPhone className="footer-contact-icon" />, text: '+254 721 858 828' },
    { icon: <FaEnvelope className="footer-contact-icon" />, text: 'jayjikos@gmail.com' },
    { 
      icon: <FaMapMarkerAlt className="footer-contact-icon" />, 
      text: 'Ruiru, Kenya' 
    }
  ];

  return (
    <footer className="footer">
      <div className="footer-container">
        <div className="footer-grid">
          {/* Company Info */}
          <div className="footer-section">
            <h3 className="footer-brand">
              Joewaki Motor Agency Limited
            </h3>
            <p className="footer-description">
              Your trusted partner for quality jikos and motor equipment. We provide top-notch installation, assembly, and maintenance services.
            </p>
          </div>

          {/* Quick Links */}
          <div className="footer-section">
            <h4 className="footer-heading">Quick Links</h4>
            <ul className="footer-links">
              {quickLinks.map((link) => (
                <li key={link.name} className="footer-link-item">
                  <Link to={link.path} className="footer-link">
                    {link.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Contact Info */}
          <div className="footer-section">
            <h4 className="footer-heading">Contact Us</h4>
            <ul className="footer-contact-list">
              {contactInfo.map((item, index) => (
                <li key={index} className="footer-contact-item">
                  <span className="contact-icon">{item.icon}</span>
                  <span className="contact-text">{item.text}</span>
                </li>
              ))}
            </ul>
          </div>

          {/* WhatsApp CTA */}
          <div className="footer-section">
            <h4 className="footer-heading">Need Help?</h4>
            <p className="footer-help-text">
              Chat with us on WhatsApp for quick assistance with your jiko or needs.
            </p>
            <a
              href="https://wa.me/254721858828"
              target="_blank"
              rel="noopener noreferrer"
              className="whatsapp-button"
            >
              <FaWhatsapp className="whatsapp-icon" /> Chat on WhatsApp
            </a>
          </div>
        </div>

        {/* Copyright */}
        <div className="footer-bottom">
          <div className="footer-bottom-content">
            <p className="copyright">
              &copy; {currentYear} Joewaki Motor Agency Limited. All rights reserved.
            </p>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
